import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { symbol as Symbol } from '@wix/santa-editor-symbols';

export default {
  ShapeScroll: () => <Symbol name="motion-scroll-shape" />,
  SkewPanScroll: () => <Symbol name="motion-scroll-skewpan" />,
  ParallaxScroll: () => <Symbol name="motion-scroll-parallax" />,
  BlurScroll: () => <Symbol name="motion-scroll-blur" />,
  ShrinkScroll: () => <Symbol name="motion-scroll-shrink" />,
  MoveScroll: () => <Symbol name="motion-scroll-move" />,
  TiltScroll: () => <Symbol name="motion-scroll-tilt" />,
  GrowScroll: () => <Symbol name="motion-scroll-grow" />,
  FadeScroll: () => <Symbol name="motion-scroll-fade" />,
  Spin3dScroll: () => <Symbol name="motion-scroll-spin3d" />,
  SlideScroll: () => <Symbol name="motion-scroll-slide" />,
  RevealScroll: () => <Symbol name="motion-scroll-reveal" />,
  ArcScroll: () => <Symbol name="motion-scroll-arc" />,
  TurnScroll: () => <Symbol name="motion-scroll-turn" />,
  SpinScroll: () => <Symbol name="motion-scroll-spin" />,
  StretchScroll: () => <Symbol name="motion-scroll-stretch" />,
  PanScroll: () => <Symbol name="motion-scroll-pan" />,
  FlipScroll: () => <Symbol name="motion-scroll-flip" />,
};
